export default __webpack_public_path__ + "static/media/flame.1afa7b11.svg";